export enum TerranisService {
    WAGO = "wago",
    PIXAGRI = "pixagri",
    OENOVIEW = "oenoview"
}